/* HeyKira theme — interactions */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  /* ---- Scroll reveal ---- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky header ---- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile navigation ---- */
  function initNav() {
    var burger = document.querySelector('[data-burger]');
    if (!burger) return;
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('is-nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('is-nav-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.body.classList.remove('is-nav-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Marquee: duplicate track for seamless loop ---- */
  function initMarquee(scope) {
    (scope || document).querySelectorAll('[data-marquee]:not([data-ready])').forEach(function (track) {
      track.setAttribute('data-ready', 'true');
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---- Disclosure (accordion) ---- */
  function initDisclosure(scope) {
    (scope || document).querySelectorAll('[data-disclosure] .disclosure__toggle').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-disclosure]');
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- Copy to clipboard ---- */
  function initCopy(scope) {
    (scope || document).querySelectorAll('[data-copy]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', 'true');
      el.addEventListener('click', function () {
        var value = el.getAttribute('data-copy');
        var hint = el.parentElement.querySelector('[data-copy-hint]');
        var done = function () {
          if (!hint) return;
          var original = hint.textContent;
          hint.textContent = hint.getAttribute('data-copied') || 'Kopiert';
          setTimeout(function () { hint.textContent = original; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = value; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta); done();
        }
      });
    });
  }

  /* ---- Product gallery ---- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-gallery]:not([data-ready])').forEach(function (gallery) {
      gallery.setAttribute('data-ready', 'true');
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.setAttribute('src', thumb.getAttribute('data-full'));
          main.setAttribute('srcset', '');
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---- Quantity stepper ---- */
  function initQty(scope) {
    (scope || document).querySelectorAll('[data-qty]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', 'true');
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 1;
          var value = (parseInt(input.value, 10) || 1) + step;
          input.value = value < 1 ? 1 : value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Variant picker ---- */
  function initVariants(scope) {
    (scope || document).querySelectorAll('[data-variants]:not([data-ready])').forEach(function (select) {
      select.setAttribute('data-ready', 'true');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var form = select.closest('form');
        if (!form) return;
        var idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = select.value;
        var priceEl = form.parentElement.querySelector('[data-price]');
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        var btn = form.querySelector('[data-add]');
        if (btn) {
          var available = opt.dataset.available === 'true';
          btn.disabled = !available;
          btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
      });
    });
  }


  /* ---- FAQ-Akkordeon ---- */
  function initFaq(scope) {
    (scope || document).querySelectorAll('[data-faq] .faq__q').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-faq]');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }


  /* ---- Reiter ---- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-tabs]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', 'true');
      var btns = box.querySelectorAll('[data-tab-btn]');
      var panels = box.querySelectorAll('[data-tab-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab-btn');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id);
          });
        });
      });
    });
  }

  function boot(scope) {
    initReveal(scope); initMarquee(scope); initDisclosure(scope); initFaq(scope); initTabs(scope);
    initCopy(scope); initGallery(scope); initQty(scope); initVariants(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader(); initNav(); boot(document);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); initHeader(); initNav(); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
